import { FC, HTMLAttributes, memo } from "react";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { useQuery } from "@apollo/client";
import { FeaturedCard, Query, eonLinkAccountsGQL } from "@onmo/graphql/graphql";
import { useStyles } from "./GameCategory.style";
import ArrowWrapper from "../ArrowWrapper/ArrowWrapper";
import { FeaturedCardItem } from "./FeaturedCardItem";
import { isTV } from "../../../utils/platform";
import { getEonSteamAccount } from "../../../models/user";
import { ConsoleByogMobileGroup } from "../../../constants/console";

interface IGameCategoryProps {
  section?: Query["page"]["items"][number];
  isShowVideo?: boolean;
  defaultCardWidth?: number;
  sessionTitle?: string;
  isHideRating?: boolean;
}

const GameCategoryComponent: FC<
  HTMLAttributes<HTMLDivElement> & IGameCategoryProps
> = (props) => {
  const classes = useStyles();
  const {
    section,
    defaultCardWidth,
    sessionTitle,
    isShowVideo,
    isHideRating,
    ...otherProps
  } = props;
  const { data: dataMe } = useQuery<{ me: Query["me"] }>(eonLinkAccountsGQL, {
    skip: !isShowVideo,
    fetchPolicy: "cache-and-network",
  });
  const eonSteamAccount = getEonSteamAccount(
    dataMe?.me?.eonLinkedAccounts || [],
  );

  if (!section?.cards?.length) return null;

  return (
    <div {...otherProps}>
      <Typography
        variant={TypographyVariant.BodyB1Medium}
        className={classes.title}
      >
        {sessionTitle || section?.title?.en || section?.group}
      </Typography>
      {isTV ? (
        <div className={classes.content}>
          {section.cards.map((f) => (
            <FeaturedCardItem
              key={f.id}
              featuredCard={f as FeaturedCard}
              isShowVideo={isShowVideo}
              defaultCardWidth={defaultCardWidth}
              classes={classes}
              steamAccountStatus={eonSteamAccount?.status}
            />
          ))}
        </div>
      ) : (
        <ArrowWrapper
          className={classes.content}
          id={`content-games-${section?.group}`}
        >
          {section.cards.map((f) => (
            <FeaturedCardItem
              key={f.id}
              featuredCard={f as FeaturedCard}
              isShowVideo={isShowVideo}
              defaultCardWidth={defaultCardWidth}
              classes={classes}
              steamAccountStatus={eonSteamAccount?.status}
              isHideRating={isHideRating}
              isByogConsole={section?.group === ConsoleByogMobileGroup}
            />
          ))}
        </ArrowWrapper>
      )}
    </div>
  );
};

export const GameCategory = memo(GameCategoryComponent);
